<script setup lang="ts" generic="T extends AnyItem = AnyItem">
import type { AnyItem, CollectionRead } from '#layers/data-model/public';
import type { RenderDisplayTemplateProps } from './RenderDisplayTemplate.vue';
import { reactiveOmit } from '@vueuse/core';
import { computed } from 'vue';
import { isEmptyDisplayTemplate, useCollection, useCollectionDisplayTemplate } from '#layers/data-model/public';

interface RenderCollectionDisplayTemplateProps extends RenderDisplayTemplateProps<T> {
	/** The read that loaded `item`, which decides the collection's display template. Rows a relation includes are `Many`. */
	read: CollectionRead;
}

const props = defineProps<RenderCollectionDisplayTemplateProps>();

const forwarded = reactiveOmit<RenderCollectionDisplayTemplateProps, 'displayTemplate' | 'read'>(props, 'displayTemplate', 'read');

const { collection } = useCollection(() => props.collectionId);
const collectionDisplayTemplate = useCollectionDisplayTemplate(() => collection.value!, () => props.read); // we can safely unwrap here because we check for a collection before rendering the display template
const displayTemplate = computed(() => isEmptyDisplayTemplate(props.displayTemplate) ? collectionDisplayTemplate.value : props.displayTemplate);
</script>

<template>
	<DisplayTemplateConfigurationError v-if="!collection" :error="$t('display_template.missing_collection')" />
	<RenderDisplayTemplate v-else v-bind="forwarded" :display-template />
</template>
